/*global jQuery, GLightbox */

var _mtm = window._mtm = window._mtm || [];
var _paq = window._paq || [];
(function ($, window, document) {
  'use strict';
  let $cookieBar = $('.js-cookiebar'),
    $bar = $('.js-cookiebar-bar'),
    // disableStr,
    trackingAdded = false,
    cookieData,
    cookiename = 'cookiehint',
    heightInt = 0,
    lightbox,
    setCookie = function (name, value, days) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/;SameSite=Lax';
    },
    getCookie = function (name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    showCookieBar = function () {
      // console.log('showCookieBar');
      $cookieBar.addClass('is-active');
      $cookieBar.attr('aria-hidden', 'false');

      $cookieBar.height($bar.outerHeight(true));

      heightInt = setInterval(function () {
        $cookieBar.height($bar.outerHeight(true));
      }, 1000);
    },
    hideCookieBar = function () {
      // console.log('hideCookieBar');
      $cookieBar.removeClass('is-active');
      $cookieBar.attr('aria-hidden', 'true');
      clearInterval(heightInt);
    },
    addTrackingCode = function () {

      if (!trackingAdded) {

        if (cookieData['matomo']) {

          // console.log('add matomo tracking');
          // add matomo
          _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.async=true; g.src='https://matomo.coop.de/js/container_OBvTl614.js'; s.parentNode.insertBefore(g,s);
        }

        trackingAdded = true;
      }
    },
    optOut = function () {
      // console.log('opt out');

      if (typeof _paq != 'undefined') {
        // console.log('opt out');
        // _paq.push(['optUserOut']);
        _paq.push(['disableCookies']);
      }
    },
    init = function () {

      if ($cookieBar.length) {

        // add cookiebar detail html to lighbox and remove the original from the dom
        const cookiedetail = document.getElementById('cookiedetail');
        const cookiedetailHtml = cookiedetail.innerHTML;

        cookiedetail.parentNode.removeChild(cookiedetail);

        lightbox = GLightbox({
          closeButton: false,
          touchNavigation: false,
          draggable: false,
          selector: '.js-lightbox-cookie',
          width: '1200px',
          height: 'auto',
          keyboardNavigation: false,
          content: cookiedetailHtml
        });

        // focus on first interactive element
        lightbox.on('open', () => {
          $('.CookieBar-detail').find('input:not(:disabled), textarea:not(:disabled), a:not(:disabled), button:not(:disabled), select:not(:disabled)').first().focus();


          if (cookieData && cookieData['matomo']) {
            $('#cookiebar-check-matomo').prop('checked', true);
          }
        });

        const cookieString = getCookie(cookiename);
        // console.log('init cookiebar: ' + cookieString);

        $(document).on('click', '.js-cookiebar-optout', function (e) {
          e.preventDefault();
          // console.log('optout');

          cookieData = {};
          cookieData['matomo'] = 0;

          // document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
          // window[disableStr] = true;

          var cookieString = JSON.stringify(cookieData);

          setCookie(cookiename, cookieString, 14);
          hideCookieBar();

          alert('OptOut erfolgreich');
        });

        $(document).on('click', '.js-cookiebar-open', function (e) {
          e.preventDefault();
          lightbox.open();
        });

        $(document).on('click', '.js-cookiebar-cancel', function (e) {
          e.preventDefault();
          lightbox.close();
        });

        $(document).on('click', '.js-cookiebar-save', function (e) {
          e.preventDefault();

          cookieData = {};
          cookieData['matomo'] = $('#cookiebar-check-matomo').is(':checked') ? 1 : 0;

          // console.log(cookieData);

          var cookieString = JSON.stringify(cookieData);
          // console.log(cookieString);

          setCookie(cookiename, cookieString, 365);
          addTrackingCode();

          lightbox.close();
          hideCookieBar();
        });

        $(document).on('click', '.js-cookiebar-decline', function (e) {
          e.preventDefault();
          // console.log('decline settings');

          cookieData = {};
          cookieData['matomo'] = 0;

          var cookieString = JSON.stringify(cookieData);

          setCookie(cookiename, cookieString, 365);
          // addTrackingCode();
          hideCookieBar();
        });

        $(document).on('click', '.js-cookiebar-accept', function (e) {
          e.preventDefault();
          // console.log('accept settings');

          cookieData = {};
          cookieData['matomo'] = 1;

          var cookieString = JSON.stringify(cookieData);

          setCookie(cookiename, cookieString, 365);
          addTrackingCode();
          hideCookieBar();
        });

        if (cookieString === null) {
          showCookieBar();
        } else {

          cookieData = JSON.parse(cookieString);

          addTrackingCode();
        }
      }

    };

  init();

})(jQuery, window, document);
